module.exports = __webpack_public_path__ + "static/img/info2.205da40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/info2.png
// module id = ww8j
// module chunks = 0